import { Injectable } from '@angular/core';
import { BdLRUCache } from '@bindoc-projects/util-lib/logic';
import {
  BdAdministrativeDistrict,
  BdAdministrativeDistrictId,
} from '@bindoc-projects/geographic-domain-lib';

const BD_ADMINISTRATIVE_DISTRICT_CACHE_SIZE = 20;

@Injectable({
  providedIn: 'root',
})
export class BdAdministrativeDistrictCache {
  private cache: BdLRUCache;

  constructor() {
    this.cache = new BdLRUCache(BD_ADMINISTRATIVE_DISTRICT_CACHE_SIZE);
  }

  public set(district: BdAdministrativeDistrict) {
    this.cache.set(district.id.toString(), district);
  }

  public get(
    districtId: BdAdministrativeDistrictId,
  ): BdAdministrativeDistrict | undefined {
    const cached = this.cache.get(districtId.value);

    if (cached) {
      return BdAdministrativeDistrict.fromObject(cached);
    }

    return undefined;
  }
}
